import styled from 'styled-components';
import { ToggleButton as ButtonBase, ToggleButtonProps } from '@mui/material';
import { ComponentSize } from '../../types/types';

type Props = ToggleButtonProps & {
  color?: 'warning' | 'error';
  size?: ComponentSize;
};

const ToggleButton = styled(ButtonBase)<Props>`
  text-transform: none;
  padding-top: 6px;
  padding-bottom: 6px;
  min-height: ${({ size }) => (size === 'large' ? '40px' : '32px')};
  height: fit-content;
  color: ${({ theme }) => theme.palette.common.gray2};
  border-color: ${({ theme }) => theme.palette.common.gray1};
  border-radius: 8px;
  white-space: nowrap;

  &.Mui-selected {
    background: ${({ theme }) => theme.palette.common.gray6};
    color: ${({ theme }) => theme.palette.common.gray2};
  }

  ${({ color, theme }) =>
    color === 'error'
      ? `
    &:hover {
        color: ${theme.palette.common.red} !important;
        background: ${theme.palette.common.lightRed} !important;
    }
    `
      : color === 'warning'
      ? `
    &:hover {
        color: ${theme.palette.common.orange} !important;
        background: ${theme.palette.common.lightOrange} !important;
    }
    `
      : ``};
`;

export default ToggleButton;
